import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "f-el-msg__inner"
}
const _hoisted_2 = ["innerHTML"]

import { FormElMsgProps } from '@/types/form/others/form-el-msg';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormElMsg',
  props: {
    msg: {}
  },
  setup(__props: any) {

const props = __props;
const iconName = computed((): string | undefined => {
  if (!props.msg) return undefined;
  const iconMap: Record<string, string> = {
    error: 'error',
    success: 'success',
  };
  return iconMap[props.msg.type];
});

return (_ctx: any,_cache: any) => {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["f-el-msg", [__props.msg?.type]])
  }, [
    (__props.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_icon, {
            name: iconName.value,
            size: "xxs"
          }, null, 8, ["name"]),
          _createElementVNode("span", {
            innerHTML: __props.msg.message
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})